import style from "./style.module.css";
import cn from "classnames";

interface IAssessmentCardGridItemProps {
    children: React.ReactNode;
    fullWidth?: boolean;
    className?: string;
}

export default function AssessmentTemplateCardGridItem({ children, fullWidth = false, className }: IAssessmentCardGridItemProps) {
    return <div className={cn(style.item, { [style.fullWidth]: fullWidth }, className)}>{children}</div>;
}